<template>
  <div class="row my-1 align-items-center info-box">
    <div class="col-20 col-sm-10 col-lg-5 sep">
      <span class="label">
        {{ $t('view-Payments.info.in_progress_count') }}
      </span>
      <span class="value">
        {{ inProgressCount }}
      </span>
    </div>
    <div class="col-20 col-sm-10 col-lg-5 sep">
      <span class="label">
        {{ $t('view-Payments.info.average') }}
      </span>
      <span class="value">
        {{ average }}
      </span>
    </div>
    <div class="col-20 col-sm-10 col-lg-5">
      <span class="label">
        {{ $t('view-Payments.info.avaiable_cash') }}
      </span>
      <span class="value">
        <span v-if="Object.keys(avaiable).length === 0">0</span>
        <span
          v-for="(value, currency) in avaiable"
          :key="currency"
          :class="`d-block w-100 ${value > 0 ? 'text-success' : (value < 0 ? 'text-danger' : '')}`"
        >
          {{ value }} {{ $currencySymbol(currency) }}
        </span>
      </span>
    </div>

    <div
      v-if="!this.$store.getters['user/hasCompletedContractData']"
      class="col-20 col-sm-10 col-lg-5 d-flex align-items-center justify-content-center justify-content-lg-start"
    >
      <not-complete-contract-data-info :add-class="'contract-data-info'" />
    </div>

    <div
      v-else
      class="col-20 col-sm-10 col-lg-5 d-flex align-items-center justify-content-center justify-content-lg-start"
    >
      <std-button
        :route-link="{name: 'payments-withdraw'}"
        add-class=""
        type="C"
        :title="$t('view-Payments.info.button.withdraw')"
      />
    </div>
  </div>
</template>

<script>
import NotCompleteContractData from '../../components/NotCompleteContractDataInfo.vue'

export default {
  components: {
    'not-complete-contract-data-info': NotCompleteContractData
  },
  computed: {
    inProgressCount () {
      return this.$store.state.payments.items.filter(i => i.status === 'in_progress' || i.status === 'new').length
    },
    average () {
      const list = this.$store.state.payments.items.filter(i => i.status === 'completed')
      if (list.length === 0) {
        return 0
      }
      const average = list.reduce((a, b) => a + (parseFloat(b.price) || 0), 0) / list.length
      return Math.round((average + Number.EPSILON) * 100) / 100
    },
    avaiable () {
      return this.$store.state.payments.balance
    }
  },
  created () {
    this.$store.dispatch('payments/getBalance')
  }
}
</script>

<style lang="scss" scoped>
  .label, .value {
    width: 100%;
    display: inline-block;
    text-align: center;
  }
  .value {
    font-size: 1.25rem;
    font-weight: 600;
  }
  .sep {
    border-right: 2px solid $nh-gray;
  }
  .contract-data-info .info-text {
    font-size: 0.75rem;
  }
</style>
